import { createContext } from 'react';

import { Store, createStore } from '../../../../../../core/store/store.js';
import { type RangeLegendState } from '../types/state.js';

export const RangeLegendStateContext = createContext<Store<RangeLegendState>>(
  createStore<RangeLegendState>({} as RangeLegendState),
);

(
  RangeLegendStateContext as typeof RangeLegendStateContext & {
    displayName: string;
  }
).displayName = 'RangeLegendStateContext';
